import { render, staticRenderFns } from "./FacturaHospedaje.vue?vue&type=template&id=5dd9d22c&scoped=true&"
import script from "./FacturaHospedaje.vue?vue&type=script&lang=js&"
export * from "./FacturaHospedaje.vue?vue&type=script&lang=js&"
import style0 from "./FacturaHospedaje.vue?vue&type=style&index=0&id=5dd9d22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9d22c",
  null
  
)

export default component.exports